import { Aesdecryption } from "../../utility/Aes/Aes";
import Urlencoder from "../../utility/Urluncoder";

export const decodeUrl = async (url) => {
  try {
    const parts = url.split("?");
    if (parts[1] && Aesdecryption(parts[1]) !== "") {
      const dectext = `?${btoa(Aesdecryption(parts[1]))}`;
      return await Urlencoder(parts[0] + "/" + dectext);
    }
    return await Urlencoder(url);
  } catch (err) {
    console.error("decodeUrl error:", err);
    return null;
  }
};